import React, { ReactElement } from 'react'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import { IconButton, Button, Grid, Typography, Slider, Tooltip } from '@material-ui/core'
// import { FaBookMedical } from "react-icons/fa";
import { MdFastRewind, MdFastForward, MdPlayArrow, MdPause, MdVolumeUp, MdFullscreen, MdVolumeOff } from "react-icons/md";

const useStyles = makeStyles({
  playerWrapper: {
    width: "100%",
    position: "relative",
  },
  controlsWrapper: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'hidden',
    background: "rgb(0,0,0,0.3)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    zIndex: 1,
  },
  controlsIcons: {
    color: "#777",
    fontSize: 25,
    transform: "scale(0.9)",
    "&:hover": {
      color: '#fff',
      transform: "scale(1)"
    }
  },
  bottomIcons: {
    marginBottom: -10,
    color: "#999",
    "&:hover": {
      color: "#fff"
    }
  },
  volumeSlider: {
    width: "20%"
  }
})

function ValueLabelComponent(props) {
  const { children, open, value } = props;

  return (
    <Tooltip open={open} enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  );
}


const PrettoSlider = withStyles({
  root: {
    color: '#FFF',
    height: 2
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

interface Props {
  onPlayPause,
  playing,
  onRewind,
  onFastForward,
  muted,
  onMute,
  valueChange,
  onVolumeSeekUp,
  volume,
  onToggleFullScreen,
  played,
  onSeek,
  onSeekMouseDown,
  onSeekMouseUp,
  elapsedTime,
  totalDuration,
  onChangeDisplayFormat,
  title
}

export default function CustomPayer({ onPlayPause, playing, onRewind, onFastForward, muted, onMute, valueChange, onVolumeSeekUp, volume, onToggleFullScreen, played, onSeek, onSeekMouseDown, onSeekMouseUp, elapsedTime, totalDuration, onChangeDisplayFormat, title }: Props): ReactElement {

  const classes = useStyles()

  return (
    <div className={classes.controlsWrapper}>
      {/* top controls */}
      <Grid container direction="row" alignItems="center" justify="space-between" style={{ padding: 16 }}>
        <Grid item>
          <Typography variant="h5" className="title-player" style={{ color: "#fff" }}>{title}</Typography>
        </Grid>
        {/* <Grid item>
							<Button
								variant="contained"
								color="primary"
								startIcon={<FaBookMedical />}
							>
								Save Image
							</Button>
						</Grid> */}
      </Grid>

      {/* middle controls */}
      <Grid container direction="row" alignItems="center" justify="center">
        <IconButton onClick={onRewind} className={classes.controlsIcons} aria-label="reqind" >
          <MdFastRewind className="icon-video-center hind-pc" />
        </IconButton>
        <IconButton onClick={onPlayPause} className={classes.controlsIcons} aria-label="reqind" >
          {playing ? (<MdPause className="icon-video-center" />) : (<MdPlayArrow className="icon-video-center" />)}
        </IconButton>
        <IconButton onClick={onFastForward} className={classes.controlsIcons} aria-label="reqind" >
          <MdFastForward className="icon-video-center hind-pc" />
        </IconButton>
      </Grid>

      {/* bottom controls*/}
      <Grid container direction="row" alignItems="center" justify="space-between" style={{ padding: 10 }}>
        <Grid item xs={12} className="pret-center" >
          <PrettoSlider style={{marginBottom: -15}}
            min={0}
            max={100}
            value={played * 100}
            ValueLabelComponent={(props) => <ValueLabelComponent {...props} value={elapsedTime} />}
            onChange={onSeek}
            onMouseDown={onSeekMouseDown}
            onChangeCommitted={onSeekMouseUp}
          />
        </Grid>
        <Grid item xs={10}>
          <Grid style={{ display: "flex", alignItems: "center" }}>

            <IconButton onClick={onPlayPause} className={classes.bottomIcons}>
              {playing ? (<MdPause className="icon-video" />) : (<MdPlayArrow className="icon-video" />)}
            </IconButton>

            <IconButton onClick={onMute} className={classes.bottomIcons}>
              {muted ? (<MdVolumeOff className="icon-video" />) : (<MdVolumeUp className="icon-video" />)}
            </IconButton>

            {/* <Grid item xs={2}> */}
            <Slider
              style={{ width: "20%", margin: 0, padding: 0, marginBottom: -10}}
              min={0}
              max={100}
              value={volume * 100}
              // className={classes.volumeSlider}
              onChange={valueChange}
              onChangeCommitted={onVolumeSeekUp}
            />
            {/* </Grid> */}
            <Button id="btn-elapsedTime" onClick={onChangeDisplayFormat} style={{ color: "#fff", marginLeft: 16, marginBottom: -10 }}>
              <Typography className="icon-video" >{elapsedTime} / {totalDuration}</Typography>
            </Button>
          </Grid>
        </Grid>
        <Grid item >
          <IconButton onClick={onToggleFullScreen} className={classes.bottomIcons}>
            <MdFullscreen />
          </IconButton>
        </Grid>
      </Grid>
    </div>
  )
}
